import { Search, X } from 'lucide-react';
import {
  type ChangeEvent,
  type ForwardedRef,
  forwardRef,
  useEffect,
  useMemo,
  useState,
} from 'react';

import Input from '../Input';
import type { SearchInputT } from './types';

const SearchInput = (
  props: SearchInputT,
  ref: ForwardedRef<HTMLInputElement>,
) => {
  const [searchValue, setSearchValue] = useState(props.value);

  const {
    sizeType = 'm',
    onClickClear,
    style,
    leftIcon,
    className,
    onChange,
    ...rest
  } = props;

  const handleOnClear = () => {
    setSearchValue('');
    onClickClear?.();
  };

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    onChange?.(e);
  };

  const InputPadding = useMemo(() => {
    switch (sizeType) {
      case 's':
        return 30;
      case 'm':
        return 32;
      default:
        return 34;
    }
  }, [sizeType]);

  useEffect(() => {
    setSearchValue(props.value);
  }, [props.value]);

  return (
    <Input
      ref={ref}
      {...rest}
      value={searchValue}
      onChange={handleOnChange}
      sizeType={sizeType}
      style={{ ...style, paddingLeft: InputPadding }}
      className={className}
      leftIcon={
        leftIcon || <Search className="size-3.5 text-muted-foreground" />
      }
      rightIcon={
        props.hasValue || searchValue ? (
          <X
            className="size-3.5 cursor-pointer text-muted-foreground"
            onClick={handleOnClear}
          />
        ) : undefined
      }
    />
  );
};

export default forwardRef(SearchInput);
